import { render } from "./tokenListPage.vue?vue&type=template&id=77de2c30&ts=true"
import script from "./tokenListPage.vue?vue&type=script&lang=ts"
export * from "./tokenListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__